export const GENERIC_ERROR_MSG = 'Houve um erro inesperado. Tente novamente e se o problema persistir, entre em contato conosco.';
export const formaPagamentoEnum = {
  PIX: 'P',
  BOLETO: 'B',
  CARTAO_CREDITO: 'C',
};
